<template>
  <OptionDetail />
</template>

<script>
const OptionDetail = () => import('@/components/Options/OptionDetail')

export default {
  components: {
    OptionDetail,
  },

  props: {},

  data() {
    return {}
  },

  computed: {},

  created() { },

  methods: {},
}
</script>

<style></style>
